import React, {Component} from 'react';
/*
    IMPORTANT: react router's BrowserRouter doesn't work when the app is "Added to home screen"
    in Chrome. You have to use HashRouter instead. If desired, you can also, choose which 
    router to use depending on environment. See https://ayastreb.me/react-router-in-home-screen-pwa/
*/
import {HashRouter as Router, Route} from 'react-router-dom';
import fscreen from 'fscreen';

import AppLoader from './AppLoader';
import './AppWrapper.css';
import WindowFitter from './WindowFitter.js';

/*
    The App component is designed with a fix width of 2048 x 1536.
    If we scale it directly, the coordinate system gets messed up (for drag and drop).
    However, if we put it inside an iframe and scale that iframe instead,
    it all works out perfectly (the iframe's 'window' coordinates are scaled automatically).
*/
class AppIframeWrapper extends Component {
    constructor(props) {
        super(props);

        var launched_from_home_screen = window.matchMedia && 
            window.matchMedia('(display-mode: fullscreen)').matches;

        this.state = {
            should_generate_fullscreen_button: fscreen.fullscreenEnabled && 
                fscreen.fullscreenElement === null && 
                !launched_from_home_screen,
        };
    }

    componentDidMount() {
        if (fscreen.fullscreenEnabled) {
            fscreen.addEventListener('fullscreenchange', this.handle_fullscreen_change);
            fscreen.addEventListener('fullscreenerror', this.handle_fullscreen_error);
        }
    }
    requestFullscreen = () => {
        fscreen.requestFullscreen(this.element);
    }
    handle_fullscreen_change = (event) => {
        this.setState({should_generate_fullscreen_button: fscreen.fullscreenElement === null});
    }
    handle_fullscreen_error = (event) => {
        // TODO - error logging?
        console.error(event);
    }
    generate_fullscreen_button() {
        // We've removed/disabled this feature
        return null;
        // return <button onClick={this.requestFullscreen} style={{
        //     position: 'absolute',
        //     top: '20%',
        //     right: '10%',
        //     zIndex: '1',
        // }}>Go Fullscreen</button>
    }

    render() {
        return <div ref={(element) => {this.element = element}} className="AppWrapper">
            <div>
                {this.state.should_generate_fullscreen_button ? this.generate_fullscreen_button() : null}
                <WindowFitter width={1024} height={768}>
                    <iframe src="./index.html#app" title="GleeBots game" style={{
                        width: '1024px',
                        height: '768px',
                        border: 'none',
                        display: 'block',
                    }}></iframe>
                </WindowFitter>
            </div>
        </div>
    }
}

class AppWrapper extends Component {
    render() {
        return <Router>
            <div style={{height: '100%'}}>
                <Route exact path="/" component={AppIframeWrapper} />
                <Route path="/app" component={AppLoader} />
            </div>
        </Router>
    }
}
export default AppWrapper;


// WEBPACK FOOTER //
// ./src/AppWrapper.js